export const phoneFormatter = (phone) => {
  if (typeof phone === "number") {
    phone = phone.toString();
  }
  if (phone) {
    if (phone.startsWith("+9")) {
      phone = phone.split("+9")[1];
    }
    if (phone.length > 11) {
      if (phone.charAt(0) === "0") {
        phone = phone.slice(0, 11);
      } else {
        phone = phone.slice(0, 10);
      }
      return phone.replace(/(\d\d\d\d)(\d\d\d)(\d\d\d\d)/, "($1) $2 $3");
    }
    if (phone.length === 10 || phone.length === 11) {
      phone = phone.length === 10 ? `0${phone}` : phone;
      return phone.replace(/(\d\d\d\d)(\d\d\d)(\d\d\d\d)/, "($1) $2 $3");
    }
    if (phone.length === 7) {
      return phone.replace(/(\d\d\d)(\d\d\d\d)/, "$1 $2");
    }
  }
  return phone;
};

export const getFormatMobilePhoneView = (phoneNumber) => {
  return String(phoneNumber)
    .replace(/\D+/g, "")
    .replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, "($1) $2 $3 $4");
};
